import React, { useEffect, useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import CallToActionButton from '../../../../../../component/call-to-action-button/call-to-action-button';
import { updateCalendarVacationOperation } from '../operations/update-calendar-vacation-operation';

interface EditCalendarVacationDialogProps {
  calendarVacationId: number;
  initialTitle: string;
  initialDescription: string;
  initialStartDate: Date | null;
  initialEndDate: Date | null;
  closeDialog: () => void;
}

function coerceToDate(value: unknown): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value as any);
  return Number.isNaN(d.getTime()) ? null : d;
}

export const EditCalendarVacationDialog: React.FC<
  EditCalendarVacationDialogProps
> = ({
  calendarVacationId,
  initialTitle,
  initialDescription,
  initialStartDate,
  initialEndDate,
  closeDialog,
}) => {
  const [title, setTitle] = useState(initialTitle ?? '');
  const [description, setDescription] = useState(initialDescription ?? '');
  const [startDate, setStartDate] = useState<Date | null>(
    coerceToDate(initialStartDate),
  );
  const [endDate, setEndDate] = useState<Date | null>(
    coerceToDate(initialEndDate),
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTitle(initialTitle ?? '');
    setDescription(initialDescription ?? '');
    setStartDate(coerceToDate(initialStartDate));
    setEndDate(coerceToDate(initialEndDate));
  }, [initialTitle, initialDescription, initialStartDate, initialEndDate]);

  const handleApprove = async () => {
    await updateCalendarVacationOperation(
      {
        calendarVacationId,
        title,
        description,
        startDate,
        endDate,
      },
      setLoading,
      closeDialog,
    );
  };

  return (
    <div>
      <EditText
        title={'כותרת'}
        value={title}
        onChange={setTitle}
        maxLength={50}
      />

      <div style={{ marginBottom: '16px' }}>
        <label style={{ fontSize: '14px', color: '#4b5563' }}>תיאור</label>
        <InputTextarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={4}
          maxLength={255}
          style={{ width: '100%', marginTop: '4px', resize: 'vertical' }}
          placeholder="תיאור"
        />
        <div style={{ marginTop: '4px', fontSize: '12px', color: '#6A6A6A' }}>
          {description.length} / 255 תווים
        </div>
      </div>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <div style={{ minWidth: '250px', flex: 1 }}>
          <label style={{ fontSize: '14px', color: '#4b5563' }}>מתאריך</label>
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate((e.value as Date) ?? null)}
            showIcon
            dateFormat="dd/mm/yy"
            style={{ width: '100%', marginTop: '4px', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
          />
        </div>

        <div style={{ minWidth: '250px', flex: 1 }}>
          <label style={{ fontSize: '14px', color: '#4b5563' }}>עד תאריך</label>
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate((e.value as Date) ?? null)}
            showIcon
            dateFormat="dd/mm/yy"
            style={{ width: '100%', marginTop: '4px', direction: 'ltr' }}
            inputStyle={{ textAlign: 'right' }}
          />
        </div>
      </div>

      <div style={{ height: '12px' }} />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CallToActionButton
          text={'אישור'}
          onClick={handleApprove}
          loading={loading}
        />
      </div>
    </div>
  );
};
